import { createSlice } from "@reduxjs/toolkit";

const adminSettingSlice = createSlice({
    name: "adminSetting",
    initialState: {
        managersData: [],
        staffMembersData: [],
        nurseStationData: [],
        totalPages: [],
        adminsData: [],
        itemsPerPage: 10
    },
    reducers: {
        setManagersData: (state, action) => {
            state.managersData = action.payload;
        },
        setStaffMembersData: (state, action) => {
            state.staffMembersData = action.payload;
        },
        setNurseStationData: (state, action) => {
            state.nurseStationData = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setAdminsData: (state, action) => {
            state.adminsData = action.payload;
        },

    }
});

export const {
    setManagersData,
    setStaffMembersData,
    setNurseStationData,
    setAdminsData,
    setTotalPages
} = adminSettingSlice.actions;

export default adminSettingSlice.reducer;